import instance from '../../../api/axios'

export interface DueReminder {
  id: string
  targetType: string
  targetId: string
  title: string
  fireAt: string
}

export const loadDueReminders = async (): Promise<DueReminder[]> => {
  const response = await instance.get('/reminders/due')
  return response.data
}

export const loadScheduledReminders = async (): Promise<DueReminder[]> => {
  const response = await instance.get('/reminders/scheduled')
  return response.data
}

export const dismissReminder = async (id: string): Promise<void> => {
  await instance.post(`/reminders/${id}/dismiss`)
}
